// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"oh_a bhb_px bhb_a bhb_w","FaqAskQuestion__outdated":"oh_b bhb_ul bhb_vz"};